import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { IconsComponent } from '../../icons/icons.component';
import { ButtonComponent } from '../button.component';

@Component({
  selector: 'vti-pop-confirm',
  templateUrl: './pop-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IconsComponent, ButtonComponent],
})
export class PopConfirmComponent {
  public title = input.required<string>();
  public visible = input.required<boolean>();

  @Output() public okClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public cancelClick: EventEmitter<void> = new EventEmitter<void>();

  public onOkClick(): void {
    this.okClick.emit();
  }

  public onCancelClick(): void {
    this.cancelClick.emit();
  }
}
